import { render, staticRenderFns } from "./roamModal.vue?vue&type=template&id=c21daf98&scoped=true&"
import script from "./roamModal.vue?vue&type=script&lang=js&"
export * from "./roamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21daf98",
  null
  
)

export default component.exports